import React, { Component } from "react";
import { Button, Popup } from "semantic-ui-react";

export default class BalanceMessage extends Component {
  render() {
    const { payment } = this.props;

    const message =
      (payment &&
        payment.balance &&
        payment.balance.balanceLimitReasons &&
        payment.balance.balanceLimitReasons.CREDITABLE_BALANCE &&
        payment.balance.balanceLimitReasons.CREDITABLE_BALANCE
          .CREDITABLE_BALANCE_MESSAGE) ||
      "";

    if (!message) {
      return <span />;
    }

    const containerStyles = {
      fontSize: "12px",
      lineHeight: "1",
      marginBottom: "20px",
      fontStyle: "italic",
      color: "#999"
    };
    const linkStyles = { color: "#E3714D", textDecoration: "underline" };

    return (
      <div style={containerStyles}>
        {message}{" "}
        <Popup
          trigger={
            <Button
              onClick={e => e.preventDefault()}
              content="Learn more"
              className="buttonLink"
              style={linkStyles}
            />
          }
          on="click"
          position="top left"
        >
          <p>
            The limit for adding money to your wallet is based on new RBI
            guidelines as well as the transactions you have done this month.
            Based on this, money may can get added to your wallet or as a
            voucher.{" "}
            <a
              href="https://support.freecharge.in/account-limits"
              style={linkStyles}
              target="4000013576"
            >
              Click here
            </a>
          </p>
        </Popup>
      </div>
    );
  }
}
